import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import { PageLayout, Main, Content, TopNavigation } from '@atlaskit/page-layout';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { SuspenseWrapper } from 'routes';

import { TopNavigationContent, Page, LeftSidebarContent } from './components';

const TopNavigationContainer = styled.div`
  z-index: 4;
  background-color: #fafbfc;
`;

const LeftSidebarContainer = styled.div<{ isOpen: boolean }>`
  position: relative;
  width: ${({ isOpen }) => (isOpen ? '255px' : '75px')};
  transition: width 0.3s ease;
`;

const LeftSideWrapper = styled.div<{ isOpen: boolean }>`
  position: fixed;
  width: ${({ isOpen }) => (isOpen ? '255px' : '75px')};
  transition: width 0.3s ease;
`;

const ContentContainer = styled.div`
  display: flex;
  & > nav {
    min-width: 75px;
    margin-top: 8px;
  }
`;

const IconButton = styled.button<{ isOpen: boolean }>`
  position: absolute;
  right: -12px;
  top: 25px;
  border: 1px solid rgba(155, 163, 167, 0.2);
  border-radius: 50%;
  background-color: transparent;
  transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});
  display: flex;
  align-items: center;
  padding: 0px;
  z-index: 5;
  background-color: #fff;

  &:hover {
    padding: 0px;
    background-color: rgb(223, 225, 230);
    cursor: pointer;

    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`;

function Layout() {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <PageLayout>
      <Content>
        <TopNavigationContainer>
          <TopNavigation height={68}>
            <TopNavigationContent />
          </TopNavigation>
          <LeftSidebarContainer isOpen={isOpen}>
            <LeftSideWrapper isOpen={isOpen}>
              <IconButton type="button" onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
                <ChevronRightIcon label="ChevronRightIcon" primaryColor="rgb(66, 82, 110)" />
              </IconButton>
              <ContentContainer>
                <LeftSidebarContent isOpen={isOpen} />
              </ContentContainer>
            </LeftSideWrapper>
          </LeftSidebarContainer>
        </TopNavigationContainer>

        <Main>
          <Page>
            <SuspenseWrapper>
              <Outlet />
            </SuspenseWrapper>
          </Page>
        </Main>
      </Content>
    </PageLayout>
  );
}

export default Layout;
